import React from 'react';
import { formElementHelper, formHelper, FormSchema } from '@jht/react-library';
import { Typography } from '@material-ui/core';
import { VirtualizedAutocomplete } from '../../components/Autocomplete/Autocomplete';
import { ExistingDigitalOrderOrganization, NewDigitalOrderOrganization } from '../../models';

export const newOrganizationFormSchema = (
  values: NewDigitalOrderOrganization,
  showHelperText: boolean,
  existingOrganizations: string[],
): FormSchema => {
  return formHelper([
    formElementHelper({
      fullWidth: true,
      name: 'name',
      label: 'Name',
      value: values.name,
      inputType: 'input',
      type: 'text',
      required: true,
      validation: {
        required: true,
        function: (value: string) =>
          !existingOrganizations.some(
            name => name.trim().toLowerCase() === value.trim().toLowerCase(),
          ),
      },
      validationMessages: {
        required: 'Name Required',
        function: 'Organization name already exists',
      },
      helperText: showHelperText ? (
        <Typography variant="caption" color="error">
          Changing organization will clear previously entered facility data.
        </Typography>
      ) : null,
    }),
  ]);
};

export const existingOrganizationFormSchema = (
  values: ExistingDigitalOrderOrganization,
  organizations: any,
  showHelperText: boolean,
): FormSchema => {
  return formHelper([
    formElementHelper({
      fullWidth: true,
      name: 'organization',
      label: 'Organization',
      value: values.organizationId ? `${values.organizationId}` : '',
      options: (organizations || []).map(o => {
        return { value: o.id.toString(), label: o.name };
      }),
      type: 'text',
      required: true,
      validation: { required: true },
      validationMessages: {
        required: 'Please select an organization.',
      },
      helperText: showHelperText ? (
        <Typography variant="caption" color="error">
          Changing organization will clear previously entered facility data.
        </Typography>
      ) : null,
      component: VirtualizedAutocomplete,
    }),
  ]);
};
